import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import {Formik} from 'formik';
import {Fade, Form, Button, Col, Container} from 'react-bootstrap';
import CommonMetaTag from './common-meta-tag';
import DatePicker, {registerLocale} from 'react-datepicker';
import r from '../images/title_r.svg';
import bg from '../images/img_bg_gradient.jpg';
import 'react-datepicker/dist/react-datepicker.css';
import {useTranslation} from 'react-i18next';
import it from 'date-fns/locale/it';
import {FaArrowLeft, FaArrowRight, FaBuilding, FaCheckCircle, FaEnvelope, FaIdCard, FaLock, FaUserPlus} from 'react-icons/fa';
registerLocale('it', it);

const SignUpPlayer = ({
  location, signUp
}) => {
  const {t} = useTranslation();
  const nextPath = new URLSearchParams(location.search || '').get('next');
  const loginPath = nextPath && nextPath.startsWith('/') && !nextPath.startsWith('//')
    ? `/login?next=${encodeURIComponent(nextPath)}`
    : '/login';
  return (
    <Formik
      initialValues={{name: null, surname: null, birthDate: null, email: null, phoneNumber: null, password: null, passwordConfirm: null, privacy0: false, privacy1: false, privacy2: false, privacy3: false, privacy4: false}}
      onSubmit={signUp}
    >
      {({
        handleSubmit,
        handleChange,
        setFieldValue,
        values
      }) => {

        return (
          <Fragment>
            <CommonMetaTag/>
            <Fade in appear style={{transition: 'opacity 0.30s linear'}}>
              <main className="signup-skywork-page" style={{backgroundImage: `url(${bg})`}}>
                <Container className="signup-skywork-container">
                  <div className="signup-skywork-shell">
                    <aside className="signup-skywork-story">
                      <div className="signup-skywork-brand"><img src={r} alt="" aria-hidden="true"/><span>Replayer</span></div>
                      <span className="signup-skywork-eyebrow">{t('MOTTO')}</span>
                      <h1>{t('CREATE_ACCOUNT')}</h1>
                      <p>{t('LOGIN_PLAYER_DESC')}</p>
                      <ul>
                        <li><FaCheckCircle aria-hidden="true"/><span>{t('LOGIN_REQUIRED')}</span></li>
                        <li><FaCheckCircle aria-hidden="true"/><span>{t('SIGN_UP_REQUIRED_HINT')}</span></li>
                      </ul>
                      <a className="signup-skywork-login-link" href={loginPath}><FaArrowLeft aria-hidden="true"/><span>{t('HAVE_ACCOUNT')} <strong>{t('ENTER')}</strong></span></a>
                    </aside>

                    <section className="signup-skywork-card">
                      <header className="signup-skywork-heading">
                        <span className="signup-skywork-heading-icon"><FaUserPlus aria-hidden="true"/></span>
                        <div><span className="signup-skywork-eyebrow">{t('TITLE_REPLAYER')}</span><h2>{t('ENTER_IN')}</h2><p>{t('SIGN_UP_REQUIRED_HINT')}</p></div>
                      </header>
                      <Form className="signup-skywork-form" onSubmit={handleSubmit}>
                        <div className="signup-skywork-section-heading"><FaIdCard aria-hidden="true"/><div><strong>{t('SIGN_UP_PERSONAL_DATA')}</strong><small>{t('SIGN_UP_PERSONAL_DATA_HINT')}</small></div></div>
                        <Form.Row>
                          <Col xs={12} sm={6} md={6}>
                            <Form.Group>
                              <Form.Label>{t('NAME')}*</Form.Label>
                              <Form.Control required name="name" placeholder={t('NAME')} type="text" maxLength={50} value={values.name || ''} onChange={handleChange}/>
                              <Form.Text className="text-muted">
                              {t('NAME')}
                              </Form.Text>
                            </Form.Group>
                          </Col>
                          <Col xs={12} sm={6} md={6}>
                            <Form.Group>
                              <Form.Label>{t('SURNAME')}*</Form.Label>
                              <Form.Control required name="surname" type="text" placeholder={t('SURNAME')} maxLength={50} value={values.surname || ''} onChange={handleChange}/>
                              <Form.Text className="text-muted">
                              {t('SURNAME')}
                              </Form.Text>
                            </Form.Group>
                          </Col>
                        </Form.Row>
                        <Form.Row>
                          <Col xs={12} sm={6} md={6}>
                            <Form.Group>
                              <Form.Label>{t('BIRTH_DATE')}*</Form.Label><br/>
                              <DatePicker
                                required
                                showMonthDropdown
                                showYearDropdown
                                peekNextMonth
                                locale="it"
                                className="form-control"
                                dateFormat="dd/MM/yyyy"
                                dropdownMode="select"
                                maxDate={new Date()}
                                selected={(values.birthDate && new Date(values.birthDate).setHours(12)) || null}
                                onChange={val => setFieldValue('birthDate', val)}/>
                              <Form.Text className="text-muted">
                              {t('BIRTH_DATE')}
                              </Form.Text>
                            </Form.Group>
                          </Col>
                          <Col xs={12} sm={6} md={6}>
                            <Form.Group>
                              <Form.Label>{t('TELEPHONE')}*</Form.Label>
                              <Form.Control required name="phoneNumber" type="tel" placeholder={t('TELEPHONE')} value={values.phoneNumber || ''} onChange={handleChange}/>
                              <Form.Text className="text-muted">
                              {t('TELEPHONE')}
                              </Form.Text>
                            </Form.Group>
                          </Col>
                        </Form.Row>
                        <div className="signup-skywork-section-heading"><FaLock aria-hidden="true"/><div><strong>{t('SIGN_UP_ACCESS_DATA')}</strong><small>{t('SIGN_UP_ACCESS_DATA_HINT')}</small></div></div>
                        <Form.Group>
                          <Form.Label>{t('EMAIL')}*</Form.Label>
                          <Form.Control required name="email" type="email" placeholder={t('EMAIL')} value={values.email || ''} onChange={handleChange}/>
                          <Form.Text className="text-muted">
                          {t('EMAIL')}
                          </Form.Text>
                        </Form.Group>
                        <Form.Row>
                          <Col xs={12} sm={6} md={6}>
                            <Form.Group>
                              <Form.Label>{t('PASSWORD')}*</Form.Label>
                              <Form.Control required name="password" type="password" placeholder={t('PASSWORD')} value={values.password || ''} onChange={handleChange}/>
                              <Form.Text className="text-muted">
                              {t('PASSWORD')}
                              </Form.Text>
                            </Form.Group>
                          </Col>
                          <Col xs={12} sm={6} md={6}>
                            <Form.Group>
                              <Form.Label>{t('PASSWORD_CONFIRM')}*</Form.Label>
                              <Form.Control required name="passwordConfirm" type="password" placeholder={t('PASSWORD_CONFIRM')} value={values.passwordConfirm || ''} onChange={handleChange}/>
                              <Form.Text className="text-muted">
                                {t('PASSWORD_CONFIRM')}
                              </Form.Text>
                            </Form.Group>
                          </Col>
                        </Form.Row>
                        <div className="signup-skywork-section-heading"><FaCheckCircle aria-hidden="true"/><div><strong>{t('PRIVACY')}</strong><small>{t('SIGN_UP_PRIVACY_HINT')}</small></div></div>
                        <div className="signup-skywork-privacy">
                          <p>{t('PRIVACY_AUTHORIZATIONS')} <a href="http://www.replayer.it" target="_blank" rel="noopener noreferrer">www.replayer.it</a> {t('LEGAL_INFO')}</p>
                          <Form.Group><Form.Check required name="privacy0" type="checkbox" label={t('CHECKBOX_SUBSCRIBER')} onChange={handleChange}/></Form.Group>
                          <Form.Group><Form.Check name="privacy1" type="checkbox" label={t('LABEL_AUTHORIZATION')} onChange={handleChange}/></Form.Group>
                          <Form.Group><Form.Check name="privacy2" type="checkbox" label={t('STREAMING')} onChange={handleChange}/></Form.Group>
                          <Form.Group><Form.Check name="privacy3" type="checkbox" label={t('NEWSLETTER')} onChange={handleChange}/></Form.Group>
                          <Form.Group><Form.Check name="privacy4" type="checkbox" label={t('DATA_TRANSFER')} onChange={handleChange}/></Form.Group>
                        </div>
                        <div className="signup-skywork-activation-note" role="note">
                          <span><FaEnvelope aria-hidden="true"/></span>
                          <div>
                            <strong>{t('SIGN_UP_ACTIVATION_NOTICE_TITLE')}</strong>
                            <p>{t('SIGN_UP_ACTIVATION_NOTICE')}</p>
                          </div>
                        </div>
                        <Button className="signup-skywork-submit" type="submit" size="lg">
                          <span>{t('SEND')}</span><FaArrowRight aria-hidden="true"/>
                        </Button>
                      </Form>
                      <div className="signup-skywork-partner-cta"><FaBuilding aria-hidden="true"/><div><strong>{t('SPORT_MANAGER')}</strong><span>{t('REPLAYER_BENEFITS')}</span></div><a href="https://www.replayer.it/diventa-partner/" target="_blank" rel="noopener noreferrer">{t('INFO')} <FaArrowRight aria-hidden="true"/></a></div>
                    </section>
                  </div>
                </Container>
              </main>
            </Fade>
          </Fragment>
        );
      }}
    </Formik>
  );
};

SignUpPlayer.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string
  }).isRequired,
  signUp: PropTypes.func.isRequired
};

export default SignUpPlayer;
